/* WJW 18: A single anchored top rail for long DPO grids.
   The original DPO table and mass-add/update buttons remain authoritative.
   No totals, line items, inventory, or discounts are calculated here. */
(() => {
  'use strict';
  const mq = window.matchMedia('(max-width: 749px)');
  const contexts = [
    { type: 'drawer', selector: '#Product-Drawer.active' },
    { type: 'pdp', selector: 'body.template-product .product-section' }
  ];
  let frame = 0;
  const visible = el => Boolean(el && el.isConnected && el.getClientRects().length);
  function topBoundary(ctx, root) {
    if (ctx.type !== 'drawer') return 0;
    const head = root.querySelector('.side-panel-header');
    if (!head) return 0;
    const r = head.getBoundingClientRect();
    // This header is the drawer's real top reference, not the middle of the table.
    return Math.max(0, Math.min(innerHeight - 160, r.bottom));
  }
  function ensure(ctx) {
    if (ctx.rail) return;
    const rail = document.createElement('div');
    rail.className = `wjw-dpo-toprail wjw-dpo-toprail--${ctx.type}`;
    rail.hidden = true;
    rail.setAttribute('aria-hidden', 'true');
    const headings = document.createElement('div');
    headings.className = 'wjw-dpo-toprail__head';
    const bottom = document.createElement('div');
    bottom.className = 'wjw-dpo-toprail__action';
    const copy = document.createElement('span');
    copy.textContent = 'Wholesale quantities';
    copy.className = 'wjw-dpo-toprail__copy';
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wjw-dpo-toprail__button';
    btn.addEventListener('click', () => {
      const source = ctx.source;
      if (ctx.rail.hidden || !source || !source.isConnected || source.disabled || source.matches('.disabled, [aria-disabled="true"]')) return;
      source.click(); // Delegate EXACTLY once to DPO's native button.
      schedule();
    });
    bottom.append(copy, btn);
    rail.append(bottom,headings);
    document.body.append(rail);
    ctx.rail = rail;
    ctx.head = headings;
    ctx.button = btn;
  }
  function hide(ctx) {
    if (ctx.rail) {ctx.rail.hidden = true;ctx.rail.setAttribute('aria-hidden','true');}
    ctx.source = null;
  }
  function update(ctx) {
    const root = document.querySelector(ctx.selector);
    if (!mq.matches || !visible(root) || (ctx.type === 'pdp' && document.body.classList.contains('wjw-mobile-overlay-active'))) return hide(ctx);
    const table = [...root.querySelectorAll('#tier-table, #bundle-table')].find(t=>visible(t) && t.querySelector('thead tr'));
    if (!table) return hide(ctx);
    const header = table.querySelector('thead');
    const columns = [...header.querySelectorAll('tr:first-child > th, tr:first-child > td')].filter(visible);
    if (!columns.length) return hide(ctx);
    const tableRect = table.getBoundingClientRect();
    const headerRect = header.getBoundingClientRect();
    const threshold = topBoundary(ctx, root);
    // Never show a floating column rail until the actual first table header
    // has moved behind the Quick Shop header / top viewport boundary.
    const inGrid = headerRect.top < threshold && tableRect.bottom > threshold + 85 && tableRect.top < innerHeight;
    if (!inGrid) return hide(ctx);
    const sources = [...root.querySelectorAll('.massAdd, .mass-add')].filter(el => visible(el) && !el.closest('.wjw-dpo-toprail'));
    const source = sources.at(-1);
    const label = source ? (source.value || source.textContent || '').replace(/\s+/g,' ').trim() : '';
    if (!source || !/^(add to cart|update cart)/i.test(label)) return hide(ctx);
    ensure(ctx);
    const parent = ctx.type === 'drawer' ? root.getBoundingClientRect() : {left:0,right:innerWidth};
    const left = Math.max(0, tableRect.left, parent.left);
    const right = Math.min(innerWidth,tableRect.right,parent.right);
    if (right-left < 150) return hide(ctx);
    const widths = columns.map(el=>Math.max(1,el.getBoundingClientRect().width));
    const signature = columns.map((cell,i)=>cell.textContent.trim()+'|'+Math.round(widths[i])).join(';');
    if (ctx.signature !== signature) {
      ctx.signature = signature;
      ctx.head.replaceChildren(...columns.map(cell => {
        const item = document.createElement('span');
        item.className = 'wjw-dpo-toprail__cell';
        item.textContent = cell.textContent.replace(/\s+/g,' ').trim();
        return item;
      }));
    }
    ctx.head.style.gridTemplateColumns = widths.map(w=>w+'fr').join(' ');
    ctx.rail.style.left = left + 'px';
    ctx.rail.style.width = (right-left) + 'px';
    ctx.rail.style.top = threshold + 'px';
    ctx.source = source;
    ctx.button.textContent = label;
    ctx.button.disabled = source.disabled || source.matches('.disabled,[aria-disabled="true"]');
    ctx.rail.hidden = false;
    ctx.rail.setAttribute('aria-hidden','false');
  }
  function refresh() {frame=0;contexts.forEach(update);}
  function schedule() {if (!frame) frame=requestAnimationFrame(refresh);}
  function init() {
    // Sections rerender asynchronously. Re-observe the new roots if they change.
    const observed = new WeakSet();
    const watch = () => contexts.forEach(c => {
      const el = document.querySelector(c.selector);
      if (el && !observed.has(el)) {
        observed.add(el);
        new MutationObserver(schedule).observe(el,{subtree:true,childList:true,attributes:true,attributeFilter:['class','disabled','value']});
      }
    });
    document.addEventListener('scroll', schedule, {capture:true,passive:true});
    document.addEventListener('input',schedule,{capture:true,passive:true});
    document.addEventListener('change',schedule,{capture:true,passive:true});
    document.addEventListener('quick-view:open',schedule);
    document.addEventListener('quick-view:close',schedule);
    window.addEventListener('resize',schedule,{passive:true});
    new MutationObserver(() => {watch();schedule();}).observe(document.body,{childList:true,subtree:false});
    watch();schedule();
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();
